import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { IDialogContext } from './models/abstractions/dialog.interface';
import { DialogType } from './models/enums/dialog.enum';

@Component({
    selector: 'app-modal',
    templateUrl: './dialog.component.html',
    styleUrls: ['./dialog.component.css'],
    standalone: false
})
export class DialogComponent {
  DialogType = DialogType;

  constructor(
    private _dialogRef: MatDialogRef<DialogComponent>,
    @Inject(MAT_DIALOG_DATA) private _context: IDialogContext
  ) {}

  get context(): IDialogContext {
    return this._context;
  }

  onConfirm(): void {
    this._dialogRef.close({ confirmed: true });
  }

  onCancel(): void {
    this._dialogRef.close({ confirmed: false });
  }
}
